"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.l = void 0;
// // import * as lodash from 'lodash'
// // import fp from 'lodash/fp'
var imports_1 = require("../lib/imports");
Object.defineProperty(exports, "l", { enumerable: true, get: function () { return imports_1.l; } });
// import assign from 'lodash/assign'
// import cloneDeep from 'lodash/cloneDeep'
// import debounce from 'lodash/debounce'
// import defaultTo from 'lodash/defaultTo'
// import filter from 'lodash/filter'
// import find from 'lodash/find'
// import forEach from 'lodash/forEach'
// import isBoolean from 'lodash/isBoolean'
// import isFunction from 'lodash/isFunction'
// import isNaN from 'lodash/isNaN'
// import isNil from 'lodash/isNil'
// import isNumber from 'lodash/isNumber'
// import isString from 'lodash/isString'
// import join from 'lodash/join'
// import map from 'lodash/map'
// import max from 'lodash/max'
// import merge from 'lodash/merge'
// import min from 'lodash/min'
// import parseInt from 'lodash/parseInt'
// import pull from 'lodash/pull'
// import random from 'lodash/random'
// import range from 'lodash/range'
// import remove from 'lodash/remove'
// import replace from 'lodash/replace'
// import reverse from 'lodash/reverse'
// import sample from 'lodash/sample'
// import some from 'lodash/some'
// import sortBy from 'lodash/sortBy'
// import split from 'lodash/split'
// import take from 'lodash/take'
// import times from 'lodash/times'
// import toArray from 'lodash/toArray'
// import union from 'lodash/union'
// import uniq from 'lodash/uniq'
// let lo = {
//   assign,
//   cloneDeep,
//   debounce,
//   defaultTo,
//   filter,
//   find,
//   forEach,
//   isBoolean,
//   isFunction,
//   isNaN,
//   isNil,
//   isNumber,
//   isString,
//   join,
//   map,
//   max,
//   merge,
//   min,
//   parseInt,
//   pull,
//   random,
//   range,
//   remove,
//   replace,
//   reverse,
//   sample,
//   some,
//   sortBy,
//   split,
//   take,
//   times,
//   toArray,
//   union,
//   uniq,
// }
// let l = lo.assign({}, lo, {
//   lowerCase: () => {
//     /*tslint:disable-next-line:no-console*/
//     console.error(
//       'this is probably not what you want, you probably want toLower',
//     )
//   },
//   // forReals_lowerCase: lodash.lowerCase,
//   clone: () => {
//     /*tslint:disable-next-line:no-console*/
//     console.error(
//       'this is probably not what you want, you probably want cloneDeep or r.clone',
//     )
//   },
//   // forReals_clone: lodash.clone,
// })
// export { l }
